import _ from 'lodash'

import { toLowerCase } from './string'
import { slugify } from './transliterate'

export const memoizedUtils = {
  /**
   * @deprecated - this function is not deprecated, the decorator is here just to attract attention to the warning
   * WARNING: THIS FUNCTION WILL INEVITABLY LEAK MEMORY!! Make sure you only leak tolerable amounts.
   * DO NOT USE THIS FOR ANYTHING OTHER THAN STABLE, PREDICTABLE SETS OF VALUES - i.e. dialog IDs.
   * Think hard before using this. If unsure, ask, or just don't use it.
   */
  DANGER__slugifyMemoized: _.memoize(slugify),
  /**
   * @deprecated - this function is not deprecated, the decorator is here just to attract attention to the warning
   * WARNING: THIS FUNCTION WILL INEVITABLY LEAK MEMORY!! Make sure you only leak tolerable amounts.
   * DO NOT USE THIS FOR ANYTHING OTHER THAN STABLE, PREDICTABLE SETS OF VALUES - i.e. dialog IDs.
   * Think hard before using this. If unsure, ask, or just don't use it.
   */
  DANGER__toLowerCaseMemoized: _.memoize(toLowerCase)
}

export const { DANGER__slugifyMemoized, DANGER__toLowerCaseMemoized } = memoizedUtils
